

(() => {
  // Initialize Lenis
  const lenis = new Lenis({
    autoRaf: true,
  });
})();

(() => {
  document.addEventListener('custom:variant:change', function (event) {
    const variant = event.detail.variant;

    // 1. Only run logic if the selected variant is Unavailable (null)
    if (variant) return;

    // 2. Identify the form. Use getAttribute to avoid collision with <input name="id">
    const form = event.detail.formId.form;
    const formId = form && form.getAttribute('id');
    if (!formId) return;

    // 3. Find the picker linked to this specific form
    const picker = document.querySelector(`variant-picker[form-id="${formId}"]`);
    if (!picker) return;

    // 4. Find the "Size" fieldset (Checking lowercase and titlecase)
    const sizeFieldset = picker.querySelector('fieldset[data-option="size"], fieldset[data-option="Size"]');
    if (!sizeFieldset) return;

    // 5. Find the first available size option (Prestige uses .is-disabled class)
    const availableLabel = sizeFieldset.querySelector('.block-swatch:not(.is-disabled)');

    if (availableLabel) {
      const inputId = availableLabel.getAttribute('for');
      const input = picker.querySelector(`#${inputId}`);

      // 6. Click it to trigger the theme's native update logic
      if (input && !input.checked) {
        // console.log('Auto-selecting available size:', input.value); // Uncomment for debugging
        availableLabel.click();
      }
    }
  });
})();

// Megamenu styles
(() => {
  const tagShopAllLinks = () => {
    document.querySelectorAll('ul.mega-menu__linklist ul.v-stack a').forEach(link => {
      const linkText = link.textContent.toLowerCase();

      if (linkText.includes('shop all') || linkText.includes('view all') || linkText.includes('see all')) {
        link.setAttribute('data-type', 'shop-all');
      }
    });
  };

  tagShopAllLinks();
})();

// gift wrapper
document.addEventListener('change', function(e) {
  if (!e.target.classList.contains('gift-wrap-toggle')) return;

  const key = e.target.dataset.key;
  const checked = e.target.checked;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      const item = cart.items.find(i => i.key === key);

      if (!item) {
        console.error('Item no encontrado');
        return;
      }

      let properties = { ...(item.properties || {}) };

      if (checked) {
        properties['Gift Wrapping'] = 'Yes';
      } else {
          properties['Gift Wrapping'] = ''; 
        console.log("eliminado");
      }

    return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: item.quantity,
          properties: properties
        })
      });
    })
   /* .then(() => {
      location.reload();
    });*/
});